export default __webpack_public_path__ + "assets/webgl/picking-18.81a9eb75.glb";